/** Bump when generated blocking content changes. Persist alongside every seed. */
export const GENERATOR_VERSION = "freeski-world-v5";
